import { render, staticRenderFns } from "./Register_component.vue?vue&type=template&id=706b40ee&scoped=true&"
import script from "./Register_component.vue?vue&type=script&lang=js&"
export * from "./Register_component.vue?vue&type=script&lang=js&"
import style0 from "./Register_component.vue?vue&type=style&index=0&id=706b40ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706b40ee",
  null
  
)

export default component.exports